mutation DeleteMarketingContacts($ids: [ID!]!) {
  deleteMarketingContacts(ids: $ids) {
    id
  }
}
